import { DateFormatPipe } from "./../shared/pipes/date-format.pipe";
import { Component, OnInit, Inject } from "@angular/core";
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { DataService } from "../shared/services/data.service";
import { RateTableRequest } from "../model/rateTableRequest.model";
import { RateTableInfo } from "../model/rateTableInformation.model";
import { DeviceDetectorService } from "ngx-device-detector";
import { EmployeeContribution, Plan } from "../model/planSelection.model";
import {
  ContributionType,
  EmployeContributionType,
} from "../model/enums/contribution-type.enum";
import { PayPeriod } from "../model/enums/pay-period.enums";

declare let $: any;

@Component({
  selector: "app-contribution",
  templateUrl: "./contribution.component.html",
  styleUrls: ["./contribution.component.css"],
})
export class ContributionComponent {
  public isDesktop: boolean;
  public isMobile: boolean;

  rateTableRequest: RateTableRequest = new RateTableRequest();
  rateTableInfo: RateTableInfo = new RateTableInfo();
  Id = 0;
  public progressBarValue = 0;
  public generatingRateTableComplete = false;
  public selectedTab: string;
  public errorDownloading = false;
  public downloadCompletedWithError = false;
  public generatingRateTableEmail = false;
  public generatingRateTablePercent = 0;
  public showCloseButton: boolean = true;
  public employerContributionTypes: any = [
    { employerContributionTypeId: 1, employerContributionTypeName: "Any Plan" },
    {
      employerContributionTypeId: 2,
      employerContributionTypeName: "Selected Plan",
    },
  ];
  public contributionAmountTypes: string[] = [
    "No Contribution",
    "Percentage",
    "Dollar Amount",
  ];
  public flatContributionAmountTypes: string[] = [
    "Employer Pays",
    "Employee Pays",
  ];
  public selectedIndex = -1;
  public carrieName: string = "";
  public minERContribution: number = 50;
  public dpContribution: number = 0;
  public selectedPlantypeBasedOn: number;
  public contributionPlans: any = [];
  public showPlans: boolean = false;
  public planId: string;
  public payPeriodList: any = [
    {
      payPeriodId: 1,
      payPeriodName: "Monthly",
    },
    {
      payPeriodId: 2,
      payPeriodName: "Semi-Monthly",
    },
    {
      payPeriodId: 3,
      payPeriodName: "Bi-Weekly",
    },
    {
      payPeriodId: 4,
      payPeriodName: "Weekly",
    },
  ];
  public payPeriodSelected: number = 1;
  public errorMsg: string;
  public showErrorMsg: string;
  public lblERToEEPercentage = true;
  erEEcontributionPercentageInputWidth: any;
  public disable: boolean = false;
  public selectedPlanId: number = 0;
  public isSamePackagePlanSelected: boolean = true;
  constructor(
    public dataService: DataService,
    private dialogRef: MatDialogRef<ContributionComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private dateFormatPipe: DateFormatPipe,
    public deviceService: DeviceDetectorService
  ) {
    this.showErrorMsg = "false";
    this.rateTableInfo = data.rateTableInfo;
    this.Id = data.Id;
    this.carrieName = data.rateTableInfo.Carrier.CarrierName;
    this.isSamePackagePlanSelected = data.isSamePackagePlanSelected;
  }

  ngOnInit() {
    this.showPlans = false;
    let instance = $.fn.deviceDetector;
    this.selectedTab = "No Contribution";
    if (this.deviceService.isDesktop()) this.isDesktop = true;
    if (this.deviceService.isMobile() || this.deviceService.isTablet())
      this.isMobile = true;
    this.bindPlans();
    this.bindData();
  }
  selectedTabValue(event) {
    this.disable = false;
    this.selectedTab = event.tab.textLabel;
    this.selectedIndex = event.index;
    this.rateTableInfo.EmployeeContribution.ContributionAmountTypeId =
      event.index;
    if(this.selectedIndex== ContributionType.EEPaysFlatAmount)  
    {
      this.rateTableInfo.EmployeeContribution.EmployerContributionTypeId =
      EmployeContributionType.AnyPlan;
    }
    if(this.selectedIndex== ContributionType.NoContribution)  
    {
      this.rateTableInfo.EmployeeContribution.EmployerContributionTypeId =
      0;
    }
  }
  private bindData(): void {
    this.payPeriodSelected = this.rateTableInfo.EmployeeContribution.PayPeriod;
    this.selectedPlantypeBasedOn =
      this.rateTableInfo.EmployeeContribution.EmployerContributionTypeId;

    this.selectedIndex =
      this.rateTableInfo.EmployeeContribution.ContributionAmountTypeId;
    if (this.selectedIndex === ContributionType.NoContribution) {
      this.selectedTab = this.contributionAmountTypes[0].toString();
    } else if (this.selectedIndex === ContributionType.Percentage) {
      this.selectedTab = this.contributionAmountTypes[1].toString();
    } else if (this.selectedIndex === ContributionType.EEPaysFlatAmount) {
      this.selectedTab = this.contributionAmountTypes[2].toString();
    }
    this.minERContribution =
      this.rateTableInfo.EmployeeContribution.EmployeeContributionPercent;
    this.dpContribution =
      this.rateTableInfo.EmployeeContribution.DependentContributionPercent;
    if (
      this.rateTableInfo.EmployeeContribution.EmployerContributionTypeId ===
      this.employerContributionTypes[1].employerContributionTypeId
    )
      this.showPlans = true;
    this.selectedPlanId =
      this.rateTableInfo.EmployeeContribution.EmployerSelectedPlanId;
  }
  private bindPlans(): void {
    let plansSelection: any = [];
    plansSelection = this.rateTableInfo.PlanSelection;
    let selectPlan = new Plan();
    selectPlan.PlanId = -1;
    selectPlan.PlanName = "Select Plan";
    selectPlan.PlanNetworkName = "Select Plan";
    this.contributionPlans.push(selectPlan);
    plansSelection.forEach((planSelection: any) => {
      planSelection.Networks.forEach((networks: any) => {
        networks.Plans.forEach((plan: any) => {
          let planDetail = new Plan();
          planDetail.PlanId = plan.PlanId;
          planDetail.PlanName = plan.PlanName;
          planDetail.PlanNetworkName =
            plan.PlanName + "-" + networks.NetworkName;
          this.contributionPlans.push(planDetail);
        });
      });
    });
  }
  public selectContributionType(contributionType: number, index: number) {
    this.selectedPlantypeBasedOn = contributionType;
    if (contributionType === EmployeContributionType.SelectedPlan) {
      this.rateTableInfo.EmployeeContribution.EmployerContributionTypeId =
        EmployeContributionType.SelectedPlan;
      let plans: any = [];
      plans = this.contributionPlans.map((obj) => ({ ...obj }));
      plans.splice(0, 1);
      this.showPlans = true;
      if (plans.length > 1) {
        this.selectedPlanId = -1;
      } else {
        this.rateTableInfo.EmployeeContribution.EmployerSelectedPlan =
          plans[0].PlanName;
        this.rateTableInfo.EmployeeContribution.EmployerSelectedPlanId =
          plans[0].PlanId;

        this.selectedPlanId = +plans[0].PlanId;
      }
    } else {
      this.rateTableInfo.EmployeeContribution.EmployerContributionTypeId =
        EmployeContributionType.AnyPlan;
      this.showPlans = false;
    }
  }
  public setContributionPlan(event: any): void {
    let plan = this.contributionPlans.filter((x) => x.PlanId === event.value);
    this.rateTableInfo.EmployeeContribution.EmployerSelectedPlan =
      plan[0].PlanName;
    this.rateTableInfo.EmployeeContribution.EmployerSelectedPlanId =
      plan[0].PlanId;
  }
  public payPeriodTypeChange(event: any, index: number): void {
    this.rateTableInfo.EmployeeContribution.PayPeriod = event.value;
    this.payPeriodSelected = event.value;
  }
  onChangeEEPercentageSlider(event) {
    if (event.value < 50) {
      this.showErrorMsg = "true";
      this.errorMsg = "At least 50% Required";
      this.minERContribution = 50;
      this.disable = true;
    } else {
      this.disable = false;
      this.errorMsg = "";
      this.rateTableInfo.EmployeeContribution.EmployeeContributionPercent =
        event.value;
    }
  }
  setPercentageZeroContribution(event: any): void {
    if (event.target.value < 50) {
      this.showErrorMsg = "true";
      this.errorMsg = "At least 50% Required";
      this.rateTableInfo.EmployeeContribution.EmployeeContributionPercent = 50;
      this.disable = true;
    } else {
      this.disable = false;
      this.errorMsg = "";
      this.rateTableInfo.EmployeeContribution.EmployeeContributionPercent =
        event.target.value;
    }
  }
  onChangeDPPercentageSlider(event: any): void {
    this.rateTableInfo.EmployeeContribution.DependentContributionPercent =
      event.value;
    this.dpContribution = event.value;
  }
  setDPPercentageZeroContribution(event: any): void {
    this.rateTableInfo.EmployeeContribution.DependentContributionPercent =
      event.target.value;
    this.dpContribution = event.target.value;
  }
  public setEmployeeDollarAmount(event: any): void {
    this.rateTableInfo.EmployeeContribution.EmployeeContributionAmount =
      event.target.value;
  }
  public setDepDollarAmount(event: any): void {
    this.rateTableInfo.EmployeeContribution.DependentContributionAmount =
      event.target.value;
  }
  confirm() {
    if (!this.isSamePackagePlanSelected) {
      this.rateTableInfo.EmployeeContribution.EmployerSelectedPlan = "";
      this.rateTableInfo.EmployeeContribution.EmployerSelectedPlanId = 0;
      this.rateTableInfo.EmployeeContribution.EmployerContributionTypeId =
        EmployeContributionType.AnyPlan;
    }
    this.dialogRef.close({
      rateTableInfo: this.rateTableInfo,
    });
  }
  close() {
    this.rateTableInfo.EmployeeContribution.EmployerContributionTypeId =
      EmployeContributionType.AnyPlan;
    this.rateTableInfo.EmployeeContribution.ContributionAmountTypeId =
      ContributionType.NoContribution;
    this.rateTableInfo.EmployeeContribution.PayPeriod = 1;
    this.rateTableInfo.EmployeeContribution.EmployeeContributionPercent = 50; //set the default value
    this.rateTableInfo.EmployeeContribution.DependentContributionPercent = 0;
    this.rateTableInfo.EmployeeContribution.EmployeeContributionAmount = 0;
    this.rateTableInfo.EmployeeContribution.DependentContributionAmount = 0;
    this.rateTableInfo.EmployeeContribution.EmployerSelectedPlan = "";
    this.dialogRef.close({
      rateTableInfo: this.rateTableInfo,
    });
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (event.target.value.length === 3) {
      return false;
    }
    if (
      event.target.value.length === 2 &&
      charCode === 48 &&
      event.target.value === "10"
    ) {
      return true;
    }
    if (event.target.value.length === 2) {
      return false;
    }
    return true;
  }
}
